
























import { Component } from "vue-property-decorator";
import CtrlButton from "@/app/core/component/CtrlButton.vue";
import WindowVue from "@/app/core/window/WindowVue";
import { Mixins } from "vue-mixin-decorator";
import BaseInput from "@/app/core/component/BaseInput.vue";
import TaskManager from "@/app/core/task/TaskManager";
import VueEvent from "@/app/core/decorator/VueEvent";
import LifeCycle from "@/app/core/decorator/LifeCycle";
import LanguageManager from "@/LanguageManager";
import TaskProcessor from "@/app/core/task/TaskProcessor";
import { Task, TaskResult } from "task";

export type ConfirmInfo = {
  target: string;
  type: "notification" | "warning" | "question";
};

@Component({
  components: { BaseInput, CtrlButton }
})
export default class SimpleConfirmWindow extends Mixins<
  WindowVue<ConfirmInfo, boolean>
>(WindowVue) {
  private info: ConfirmInfo | null = null;
  private message: string | null = null;

  @TaskProcessor("language-change-finished")
  private async languageChangeFinished(
    task: Task<never, never>
  ): Promise<TaskResult<never> | void> {
    const type = this.windowInfo.type;
    const target = this.info!.target;
    this.windowInfo.title = LanguageManager.instance.getText(
      `${type}.${target}.title`
    );
    this.message = LanguageManager.instance.getText(
      `${type}.${target}.message`
    );
    task.resolve();
  }

  @LifeCycle
  public async mounted() {
    await this.init();
    this.info = this.windowInfo.args!;
    const type = this.windowInfo.type;
    const target = this.info!.target;
    this.windowInfo.title = LanguageManager.instance.getText(
      `${type}.${target}.title`
    );
    this.message = LanguageManager.instance.getText(
      `${type}.${target}.message`
    );
  }

  @VueEvent
  private async commit() {
    await this.finally(true);
  }

  @VueEvent
  private async rollback() {
    await this.finally(false);
  }
}
